import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useMemo } from 'react';
import BillingStripeForm from 'lib.components/src/components/BillingStripeForm/form';
import SkeletonStripe from './SkeletonStripe';
import { Intent } from 'lib.store/src/main/payment/models';

interface BillingStripeFormWrapperProps {
  intent: Intent | null;
  apiKey: string | null;
  withPlug?: boolean;
}

const BillingStripeFormWrapper = ({
  intent,
  apiKey,
  withPlug: _withPlug = false,
}: BillingStripeFormWrapperProps) => {
  if (!intent || !apiKey) {
    return <SkeletonStripe />;
  }

  const stripeOptions = {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    clientSecret: intent.client_secret,
    // Fully customizable with appearance API.
    appearance: {
      /*...*/
    },
  };

  const stripePromise = useMemo(() => loadStripe(apiKey), [apiKey]);

  return (
    <Elements stripe={stripePromise} options={stripeOptions}>
      <BillingStripeForm />
    </Elements>
  );
};

export default BillingStripeFormWrapper;
